<template>
  <button
    :class="$b()"
    @click="$emit('click')"
  >
    <VisionIcon
      icon="plus"
      :class="$b('icon')"
    />
    Select Product
    <br />
    to Compare
  </button>
</template>

<script>
export default {
  name: 'ComparisonSelectButton',
  emits: ['click']
}
</script>

<style lang="postcss">
.ComparisonSelectButton {
  @apply text-center text-base md:text-2xl leading-tighter tracking-tight text-white
    mx-auto;
  padding-top: 66%;
}

.ComparisonSelectButton .ComparisonSelectButton__icon {
  @apply block;

  svg {
    @apply mb-sm mx-auto;
  }
}
</style>
